import React from 'react';
import { Toaster } from 'react-hot-toast';
import UserTable from './table/UserTable';
import useFetchEmployeeRecords from './hooks/useFetchEmployeeRecords';
import useFetchVendorRecords from './hooks/useFetchVendorRecords';
import useFetchTaxTypeRecords from './hooks/useFetchTaxTypeRecords';
import useFetchItemRefs from '../MyTime/hooks/useFetchItemRefs';

const User = () => {
  const { rows, setRows, employeeLoading, employeeError } = useFetchEmployeeRecords();

  //for inline editing in user table: if PopupEditing/ Accounting section exists
  const { vendorList } = useFetchVendorRecords();
  const { taxTypeRecords } = useFetchTaxTypeRecords();
  const { itemRefs } = useFetchItemRefs();

  const userRoleRecords = [
    { value: 'User', label: 'User', id: 'User' },
    { value: 'Admin', label: 'Admin', id: 'Admin' }
  ];

  return (
    <div>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          duration: 3000,
          success: {
            style: {
              background: '#36c95e',
              color: '#fff'
            }
          },
          error: {
            style: {
              background: '#f5251d',
              color: '#fff'
            }
          }
        }}
      />
      {employeeError && <div>Error: {employeeError}</div>}
      {employeeLoading ? (
        <div>Loading...</div>
      ) : (
        <UserTable
          rows={rows}
          setRows={setRows}
          vendorRefs={vendorList}
          taxTypeRecords={taxTypeRecords}
          userRoleRecords={userRoleRecords}
          itemRefs={itemRefs}
        />
      )}
    </div>
  );
};

export default User;
